export default {"src":"/_next/static/media/Group-42880.ca361450.svg","height":78,"width":85};